import { useEffect, useRef } from 'react';

// Like useEffect but not fire on first render
const useEffectUpdate = (func, deps) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) func();
        else didMount.current = true;
    }, deps);
};

export default useEffectUpdate;
